<template>
    <div class="rate">
        <div class="container" v-if="stepOne">
            <div class="row justify-content-center">
                <div class="col-md-12 col-lg-11">
                    <div class="title-row">
                        <div class="row">
                            <div class="col-md-12">
                                <p class="p-title Raleway p-black"><b>Rate Teckna.El</b></p>
                            </div>
                        </div>
                    </div>
                    <div class="rate__blck">
                        <div class="row">
                            <div class="col-md-6 brdr-right">
                                <div class="rate__main rate__left">
                                    <div class="rate__title">
                                        <p class="relawaySM max-max p-black">How do you rate us</p>
                                    </div>
                                    <div class="rate__star">
                                        <div class="star__item"

                                             v-for="star in stars"
                                             :key="star.id"
                                             @mouseover="setStar(star.id)"
                                             @click="setStar(star.id)"
                                             :style="{ background: 'url('+star.style +')' }"
                                        >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="rate__main rate__right">
                                    <div class="rate__title">
                                        <p class="relawaySM max-max p-black">Write your review</p>
                                    </div>
                                    <div class="rate__form">
                                        <div class="form-group">
                                            <label @click="forLabelClick($event)">Your message</label>
                                            <textarea class="form-control"
                                                      @focus="formControlFocus($event)"
                                                      @blur="formControlBlur($event)"
                                                      rows="5"
                                                      cols="10"
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-md-4">
                                <div class="rate__btns">
                                    <button
                                            class="btn btn-green btn-full"
                                            @click="stepTwoActive()"
                                    >continue</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container win__blck" v-if="stepTwo">
            <div class="row justify-content-center">
                <div class="col-md-12 col-lg-11">
                    <div class="title-row">
                        <div class="row">
                            <div class="col-md-12">
                                <p class="p-title Raleway p-black"><b>Try to win Apple Watch</b></p>
                            </div>
                        </div>
                    </div>
                    <div class="win__blck">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="content">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>


                                </div>
                            </div>
                            <div class="col-md-4 text-center">

                                    <img src="/img/38-alu-space-sport-black-nc-1up_GEO_RU.png" alt="" class="img-fluid">

                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-md-6">
                                <div class="rate__btns">
                                    <button
                                            class="btn btn-green btn-full"
                                            @click="openModal()"
                                    >Submit with Facebook
                                        <img src="/img/icon/facebook-logo.svg" alt="">
                                    </button>
                                    <button
                                            class="btn btn-full btn__link"
                                            @click="openModal()"
                                    >I don't want to participate
                                        </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="info-popup info-popup__facebook open" v-if="modal">
            <div class="popupoverlay"   @click="closeModal()"></div>
            <div class="mainpopup minipopup__facebook">
                <div class="close" @click="closeModal()"></div>
                <div class="popup_body">
                    <div class="text-center img">
                        <img src="/img/icon/Peace.svg" alt="">
                    </div>
                    <div class="title text-center">
                        <p class="Raleway p-black max-max"><b>Thank you</b></p>
                    </div>
                    <div class="content text-center">
                        <p class="min">Your review has been accepted and will be published soon.</p>
                    </div>
                    <div class="submit__btn">
                        <div class="row justify-content-center">
                            <div class="col-md-6">
                                <button class="btn btn-green btn-full small">nice!</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Rate",
        data: function(){
            return {
                stars: [
                    {'id': 1, 'style' : '/img/icon/star_big_green.svg'},
                    {'id': 2, 'style' : '/img/icon/star_big_green.svg'},
                    {'id': 3, 'style' : '/img/icon/star_big_green.svg'},
                    {'id': 4, 'style' : '/img/icon/star_big_green.svg'},
                    {'id': 5, 'style' : '/img/icon/star_big_gray.svg'},
                ],
                rate: 4,
                stepOne: true,
                stepTwo: false,
                modal: false,
            }
        },
        methods: {
            openModal: function(){
                this.modal = true;

            },
            closeModal: function(){
                this.modal = false;
            },
            stepTwoActive(){
                this.stepOne = false;
                this.stepTwo = true;
            },
            setStar(index){

                let DataStar = this.stars;
                this.rate = index;
                DataStar.map(function (item) {
                    if(index >= item.id ){
                        item.style= '/img/icon/star_big_green.svg';
                    } else {
                        item.style= '/img/icon/star_big_gray.svg';
                    }
                });
            },

            formControlFocus($event){
                $event.target.parentElement.classList.add('active');

            },
            formControlBlur($event){
                if($event.target.value === ""){
                    $event.target.parentElement.classList.remove('active');

                }

            },
            forLabelClick($event){
                console.log($event);
                if(!$event.target.parentElement.classList.contains("disabled")){
                    $event.target.parentElement.classList.add('active');
                    $event.target.parentElement.children[1].focus();
                }

            },
        }
    }
</script>